<template>
  <HomeAdminButtonSkeletonLoader v-if="loading" />
  <v-btn
    v-else
    elevation="0"
    :variant="!hovered ? 'outlined' : 'elevated'"
    :color="buttonColor"
    class="home-admin-button"
    rounded
    @click="$emit('updateAdminView', !isAdminOn)"
    @mouseenter="hovered = true"
    @mouseleave="hovered = false"
  >
    <DpplSvg
      v-if="isAdminOn"
      file-name="admin-icon"
      class="mr-2 admin"
    />
    Admin View {{ isAdminOn ? '' : 'Off' }}
    <DpplSvg
      v-if="!isAdminOn"
      file-name="admin-icon"
      class="ml-2"
    />
  </v-btn>
</template>

<script>
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
import HomeAdminButtonSkeletonLoader from '@/components/home/HomeAdminButton/HomeAdminButtonSkeletonLoader.vue';
import { useColors } from '@/composables/colors';

export default {
  name: 'HomeAdminButton',
  components: {
    DpplSvg,
    HomeAdminButtonSkeletonLoader,
  },
  props: {
    isAdminOn: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['updateAdminView'],
  setup() {
    const { brandPrimary, textDarkest } = useColors();

    return { brandPrimary, textDarkest };
  },
  data() {
    return {
      hovered: false,
    };
  },
  computed: {
    buttonColor() {
      if (this.isAdminOn) {
        return this.brandPrimary;
      }

      return this.textDarkest;
    },
  },
};
</script>

<style lang="less" scoped>
.home-admin-button {
  text-transform: none;
  padding: 8px !important;
  font-size: 12px;
  font-weight: 700;
  margin-top: 55px;
  box-shadow: none !important;

  :deep(svg) path {
    fill: @icon-darkest;
  }

  :deep(svg).admin path {
    fill: @icon-brand;
  }

  &:hover {
    color: @white !important;
    background: v-bind(buttonColor);

    :deep(svg) path {
      fill: @white !important;
    }

  }

}
</style>
